export default __webpack_public_path__ + "static/media/right-arrow.e73d6471.svg";